import { api } from '../services/api'; // 存放所有加载器

var LOADERS = new Map();
/**
 * 注册新的加载器
 * 加载器结构为 { get, post, put, delete }，当 method 未定义时视为不支持
 * @param apiPath 加载器处理的 url，不包含 /loader/ 前缀
 * @param loader 加载器定义
 */

export function registerLoader(apiPath, loader) {
  if (LOADERS.has(apiPath)) {
    throw new Error("Loader for url " + apiPath + " is registered.");
  }

  LOADERS.set(apiPath, loader);
}
/**
 * 数据加载器入口，通过 apiPath 区分是否使用特定加载器
 * 需要使用加载器的 apiPath 前缀固定为 /loader/
 * 不使用特定加载器或加载器未提供对应 method 时使用 api 默认行为加载
 *
 * **为了避免对entity和saga造成过大的改动，目前直接在loader中转成新api结构**
 *
 * @param method 请求类型
 * @param data 请求数据和请求配置的合并对象 RequestParams & ApiRequestConfig
 */

export function load(method, data) {
  // 为了避免对entity和saga造成过大的改动，目前直接在loader中转成新api结构
  var apiPath = data.apiPath,
      apiRoot = data.apiRoot,
      paramsFilter = data.paramsFilter;
  var params = data.params;
  var apiParams = params;
  var apiConfig = {
    apiPath: apiPath,
    apiRoot: apiRoot,
    paramsFilter: paramsFilter
  };

  if (/^\/loader\/(.+)\/:id$/i.test(apiConfig.apiPath) || /^\/loader\/(.+)$/i.test(apiConfig.apiPath)) {
    var path = '/' + RegExp.$1;
    var loader = LOADERS.get(path);
    apiConfig.apiPath = apiConfig.apiPath.substring(7);
    var loaderMethod = loader ? loader[method] : undefined;

    if (loaderMethod) {
      return loaderMethod(apiParams, apiConfig);
    }
  }

  return api[method](apiParams, apiConfig);
}